import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogModule } from 'primeng/dialog';
import { PDialogWrapperComponent } from './pdialog-wrapper.component';

@NgModule({
  declarations: [PDialogWrapperComponent],
  imports: [CommonModule, DialogModule],
  exports: [PDialogWrapperComponent]
})
export class PDialogWrapperModule {}
